import {createContext} from 'react'

export const ServiceFollowUpContext = createContext({
  modalOpen: false,
  setModalOpen: () => {
  },
  serviceFollowUps: [],
  setServiceFollowUps: () => {
  },
  serviceFollowUp: {
    id: null,
    service_id: null,
    person_name: "",
    person_phone: "",
    agent_name: "",
    agent_phone: "",
    branch_name: "",
    step_title: "",
    step_description: "",
    step: null,
    days: null,
    updated_at: "",
    created_at: "",
    dead_line: "",
    all_done: null,
    days_to_dead_line: null,
    total_planned_days_from_payment: null,


  },
  setServiceFollowUp: () => {
  },
  lastDataRefresh: Date.now(),
  setLastDataRefresh: () => {
  },
  roleId: null,
  setRoleId: () => {
  },
})